export const sortZtoA = (array: any[], sortString: string) => {
  return array.sort((a, b) => {
    return b[sortString].localeCompare(a[sortString]);
  });
};
